<script>
import { authComputed } from '@store/helpers'
import { getLocalStorage } from '@utils/localStorage'

export default {
  page: {
    // All subcomponent titles will be injected into this template.
    titleTemplate(title) {
      let appTitle = ''
      if (process.env.VUE_APP_MODE === 'ipetbooking') {
        appTitle = 'i 寵訂 | iPet Booking'
      } else {
        appTitle = 'DingBeauty 美容服務系統'
      }
      title = typeof title === 'function' ? title(this.$store) : title
      return title ? `${title} | ${appTitle}` : appTitle
    },
  },
  name: 'App',
  computed: {
    ...authComputed,
    isDevelopment() {
      return process.env.NODE_ENV === 'development'
    },
    isDisplayPreMode() {
      return getLocalStorage('set.displayPre') === true
    },
  },

  mounted() {
    const initVarVh = () => {
      this.varVh = window.innerHeight * 0.01
    }

    initVarVh()

    window.addEventListener('resize', () => {
      initVarVh()
    })
  },
}
</script>
<template>
  <div id="app" :class="{ development: isDevelopment, displayPreMode: isDisplayPreMode }">
    <!--
    Even when routes use the same component, treat them
    as distinct and create the component again.
    -->
    <RouterView :key="$route.fullPath" />
  </div>
</template>

<!-- This should generally be the only global CSS in the app. -->
<style lang="scss">
$grid-gutter-width: $container-gap * 2;

@import '~bootstrap/scss/bootstrap';

// Normalize default styles across browsers,
// https://necolas.github.io/normalize.css/
@import '~normalize.css/normalize.css';

// Style loading bar between pages.
// https://github.com/rstacruz/nprogress
@import '~nprogress/nprogress.css';
@import '@styles/index.scss';

@media (min-width: 1200px) {
  .section {
    padding-top: 100px;
    padding-bottom: 100px;
  }
}
body {
  color: #0c1c30;
}

.dingbeauty-title {
  line-height: 1.7;
}
</style>

<style>
@font-face {
  font-family: IvyMode;
  src: url('./IvyMode-Regular.woff2');
}

.fancy-title {
  font-family: 'IvyMode', Times, serif;
}
.section {
  padding-top: 60px;
  padding-bottom: 60px;
}

@media (min-width: 992px) {
  .section {
    padding-top: 100px;
    padding-bottom: 100px;
  }
}
</style>
